import React from "react";
import {
  LANGUAGE_OPTIONS,
  getLanguageCopy,
  normalizeLanguage,
} from "../services/language";

const LanguageSelector = ({
  language,
  onChange,
  showDescription = true,
  compact = false,
  className = "",
}) => {
  const currentLanguage = normalizeLanguage(language);
  const gridClass = compact
    ? "grid grid-cols-4 gap-2"
    : "grid grid-cols-1 gap-2 sm:grid-cols-2";

  return (
    <div className={`${gridClass} ${className}`.trim()}>
      {LANGUAGE_OPTIONS.map((option) => {
        const isActive = currentLanguage === option.value;
        return (
          <button
            key={option.value}
            type="button"
            onClick={() => onChange(option.value)}
            className={`rounded border px-3 py-3 text-left transition ${
              isActive
                ? "border-[#f7b531] bg-[#2b1c0f] text-[#ffd66b]"
                : "border-[#3c2414] bg-[#120d09] text-[#f8f2e6]/75 hover:border-[#f7b531]/75 hover:text-[#ffd66b]"
            }`}
          >
            <div className="flex items-center justify-between gap-2">
              <span className="text-sm font-bold uppercase tracking-wide">
                {compact ? option.shortLabel : option.nativeLabel}
              </span>
              {!compact ? (
                <span className="text-[11px] uppercase tracking-[0.18em] opacity-70">
                  {option.shortLabel}
                </span>
              ) : null}
            </div>
            {showDescription && !compact ? (
              <div className="mt-1 text-xs opacity-80">
                {getLanguageCopy(currentLanguage, option.description)}
              </div>
            ) : null}
          </button>
        );
      })}
    </div>
  );
};

export default LanguageSelector;
